<div layout-vertical layout-full-width padding-lr>
  <div class="row-wrap" padding-tb-small-x layout layout-align-items-center layout-space-between>
    <div class="heading-wrap" layout layout-align-items-center>
      <rt-heading>{{ title }}</rt-heading>
    </div>
    <div class="rating-wrap" layout>
      @for (rating of ratings; track trackByRating($index, rating)) {
        @if (rating.count) {
          <div class="rating-box" layout padding-small-x>
            <rt-interview-evaluation-rating [rating]="rating.ratingKey" [tooltip]="false">
            </rt-interview-evaluation-rating>
            <strong>{{ rating.count }}</strong>
          </div>
        }
      }
    </div>
  </div>

  <rt-divider></rt-divider>
</div>
